import Phaser from "phaser"

import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { ModuleCollection, Base } from "./modules";

interface ArrangeOptions {
  count?: number
  px: number
  py: number
  sx?: number
  sy?: number
}


export class cContainer extends Phaser.GameObjects.Container {

  public modules: ModuleCollection;

  private arrangeMode: string 
  private arrangeOptions: ArrangeOptions 



  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0);
    this.modules = Base.initModules(this,data);

    this.arrangeMode = data.arrange ? data.arrange : ''
    var arOp = data.arrangeoptions ? JSON.parse(data.arrangeoptions) : {}
    this.arrangeOptions = {...{px:10,py:10,count:99999},...arOp}

    if (sc.debugMode){
      let _debugRect = new Phaser.GameObjects.Graphics(sc) //  this.ref.add.graphics();

      if (!data.asset) {
        console.warn('No Size in asset - for debugging')
        return
      }

      var r:any = this.modules.layout.getOfs( data.asset as string )
      if (!r) r={x:100,y:100}

      _debugRect.lineStyle(1, 0xff9900, 0.8);
      _debugRect.x = 0;
      _debugRect.y = 0;      
      _debugRect.fillStyle(0xff9900,0.2)
      _debugRect.fillRect(0,0,r.x,r.y)
      _debugRect.strokeRect(0, 0, r.x, r.y);
      this.add(_debugRect)

    }
  }

  set itemDepth(v:number){
    this.setDepth(v);
    if (this.parentContainer){
      this.parentContainer.sort('depth')
    }    
  }

  private getArrangeHeight(ref:any):number{
    var v = this.arrangeOptions.sy ? this.arrangeOptions.sy : ref.height
    return v+this.arrangeOptions.py
  }

  private getArrangeWidth(ref:any):number{
    var v = this.arrangeOptions.sx ? this.arrangeOptions.sx : ref.width
    return v+this.arrangeOptions.px
  }


  public arrange(){
    var objList = this.getAll()

    var xx = 0;
    var yy = 0;
    var cc = 0;
    objList.forEach( (obj:any,i)=>{
      obj.x = xx
      obj.y = yy
      cc ++;
      //console.log(this.arrangeMode,xx,yy,cc)
      switch (this.arrangeMode){
        case 'horizontal':
          if (this.arrangeOptions.count && cc > this.arrangeOptions.count-1 ){
            xx = cc = 0
            yy += this.getArrangeHeight(obj)
          }else{
            xx += this.getArrangeWidth(obj)
          }
          break;  
        case 'vertical':
          if (this.arrangeOptions.count && cc > this.arrangeOptions.count-1 ){
            yy = cc = 0
            xx += this.getArrangeWidth(obj)
          }else{
            yy += this.getArrangeHeight(obj)
          }
          break;
        default:
      }
    });
  }


}